export const lg = 1023
export const md = 768
export const sm = 575
